import { useSnackbar } from 'notistack';
import React, { useCallback } from 'react';
import Iconify from '@emfood/shared/src/components/iconify';

import { Tooltip, IconButton, IconButtonProps } from '@mui/material';

import { useCopyToClipboard } from 'src/hooks/use-copy-to-clipboard';

interface Props extends IconButtonProps {
  copiedText: string | null;
  iconSize?: number;
}

export const CopyToClipboard = ({ copiedText, iconSize, ...rest }: Props) => {
  const { enqueueSnackbar } = useSnackbar();
  const { copy } = useCopyToClipboard();

  const onCopy = useCallback(
    (event: React.MouseEvent<HTMLElement>) => {
      event.stopPropagation();
      if (copiedText) {
        enqueueSnackbar('Copied!');
        copy(copiedText);
      }
    },
    [copiedText, copy, enqueueSnackbar]
  );

  return (
    <Tooltip title="Copy">
      <IconButton {...rest} onClick={onCopy}>
        <Iconify icon="eva:copy-fill" width={iconSize ?? 24} />
      </IconButton>
    </Tooltip>
  );
};
